module.exports = __webpack_public_path__ + "static/img/l-4.7cdf48df.png";